import React from 'react';
import './Loader.scss';

/**
 * Brand spinner.
 *
 * `fullscreen` is opt-in now. It used to be the only mode — a fixed,
 * 100vh, opaque white overlay — which meant any inline "loading"
 * state blanked the entire page, header and all.
 */
const Loader = ({ fullscreen = false, label = 'Loading…' }) => (
  <div
    className={`loader${fullscreen ? ' loader--fullscreen' : ''}`}
    role="status"
    aria-live="polite"
  >
    <span className="loader__ring" aria-hidden="true" />
    <span className="visually-hidden">{label}</span>
  </div>
);

export default Loader;
